<template>
  <section class="custom-manage">
    <z-tabs v-model="currentTab" :tabs="tabs" @change="showTab" />
    <div class="custom-name">{{ orgName }}</div>
    <div class="row p-3" v-if="currentTab === 'Coach'">
      <members-listing ref="summary" :orgid="orgid" />
    </div>
    <div class="row p-3" v-if="currentTab === 'Wellness Wall'">
      <feed :orgid="orgid" />
    </div>
    <div class="row p-3" v-if="currentTab === 'Admin'">
      <member-admin :orgid="orgid" />
    </div>
    <div class="row p-3" v-if="currentTab === 'Reporting'">
      <reporting-dashboard />
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import ZTabs from '@/Components/ZElements/Tabs'
import MembersListing from '@/Components/UserCardio/summary/members-listing'
import MemberAdmin from '@/Components/UserCardio/summary/member-admin'
import ReportingDashboard from '@/Components/Reporting/dashboard'
import Feed from '@/Components/Feed/feed-listing'
export default {
  name: 'usercardio-manage',
  components: {
    ZTabs,
    MembersListing,
    MemberAdmin,
    ReportingDashboard,
    Feed,
  },
  data() {
    return {
      currentTab: 'Coach',
      tabs: ['Coach', 'Wellness Wall', 'Admin', 'Reporting'],
      orgid: null,
    }
  },
  mounted() {
    console.log('Examining Organization', {
      route: this.route().params,
      org: this.examineOrganization,
    })
    this.orgid = 0
    if (this.route().params.id) {
      this.orgid = parseInt(this.route().params.id)
    }
  },
  computed: {
    ...mapGetters('organizations', ['examineOrganization']),
    orgName() {
      let _name = ''
      if (this.examineOrganization) {
        _name = this.examineOrganization.name
      }
      console.log('Manage', this.examineOrganization)
      return _name
    },
  },
  methods: {
    showTab(value) {
      this.currentTab = value
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-manage {
  position: relative;
  height: 100%;
  width: 100%;
}
.custom-name {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
